<template>
  <add-note-card
    v-if="openWindow === 'add-note'"
    :contact="contact"
    @close="close"
  />
  <delete-contact
    v-if="openWindow === 'delete-contact'"
    :contact="contact"
    @close="close"
  />
  <edit-contact
    v-if="openWindow === 'edit-contact'"
    :contact="contact"
    @close="close"
  />
  <reset-password
    v-if="openWindow === 'reset-password'"
    :contact="contact"
    @close="close"
  />
  <email v-if="openWindow === 'email'" :contact="contact" @close="close" />
  <div id="contact-page-wrapper">
    <div id="contact-page-heading">
      <heading
        :heading="`${givenName} ${familyName}`"
        :subheading="email"
        :secondarySubheading="phoneNumber"
        :profile-picture="profilePicture"
        :show-profile-picture="true"
      />
      <!-- todo : build popups to display for icons -->
      <icon-bar id="icon-bar" :icons="icons" @icon-clicked="iconClicked" />
    </div>
    <div id="contact-page-alert-scroller">
      <alert-card
        v-for="(alert, index) in alertCards"
        :key="index"
        :display="alert.display"
        :primaryHeading="alert.primaryHeading"
        :button-text="alert.buttonText"
        :icon="alert.icon"
        :middleHeading="alert.middleHeading"
        @action-taken="alert.action()"
      />
    </div>
    <div id="contact-page-components">
      <upcoming-events
        id="scs-contact-page-upcoming-events"
        heading="Upcoming Events"
        :contact="contact"
      />
      <notes
        id="scs-contact-page-notes-list"
        heading="Notes"
        :contact="contact"
        @icon-clicked="iconClicked('add-note')"
      />
      <automations-list
        id="scs-contact-page-automation-list"
        heading="Automations"
        :contact="contact"
      />
    </div>
  </div>
</template>
<script>
import Heading from "../Components/UI/Heading.vue";
import IconBar from "../Components/UI/IconBar.vue";
import AlertCard from "../Components/UI/AlertCard.vue";
import UpcomingEvents from "../Components/UpcomingEvents.vue";
import Notes from "../Components/Notes.vue";
import AutomationsList from "../Components/AutomationsList.vue";
import AddNoteCard from "../Components/UI/FloatingCards/Contact/AddNoteCard.vue";
import DeleteContact from "../Components/UI/FloatingCards/Contact/DeleteContact.vue";
import EditContact from "../Components/UI/FloatingCards/Contact/EditContact.vue";
import ResetPassword from "../Components/UI/FloatingCards/Contact/ResetPassword.vue";
import Email from "../Components/UI/FloatingCards/Contact/Email.vue";
import { formatDate, total, formatPrice } from "../Helpers/invoice";
export default {
  data() {
    return {
      icons: ["reset-password", "edit", "email", "trash-can"],
      openWindow: undefined,
    };
  },
  computed: {
    role() {
      return this.$store.getters.userRole;
      // todo : use role to conditionally build components and permissions within each component
    },
    alertCards() {
      // let automationCount = () => {
      //   return this.contact.automations ? this.contact.automations.length : "-";
      // };
      let contactLastActive = () => {
        if (this.contact) {
          return this.contact.latestSession
            ? formatDate(this.contact.latestSession)
            : " - October 13, 2022";
        }
        // todo : attach login lambda to add latestSession to db item and update when login
        // todo : update above date to date when aforementioned lamda is implemented
      };
      let contactEventCount = () => {
        if (this.contact) {
          return this.contact.associatedEvents
            ? this.contact.associatedEvents.length
            : "-";
        }
      };
      let contactInvoiceTotal = () => {
        if (this.contact) {
          if (this.contact.eventsRetrieved) {
            return this.contact.associatedEvents.reduce((a, b) => {
              return a + total(b);
            }, 0);
          }
        }
      };
      let alerts = [
        // todo : build and insert this
        // {
        //   // todo : bring in messages with user and contact, and conditionally push
        //   display: "button-with-icon",
        //   primaryHeading: "1 New Message",
        //   buttonText: "Messages",
        //   icon: "chat",
        //   action: () => {
        //     this.openMessages();
        //   },
        // },
        // todo : build and insert this
        // {
        //   display: "button-with-icon",
        //   primaryHeading: `${automationCount()} Automations`,
        //   buttonText: "Review / Edit",
        //   icon: "automation",
        //   action: () => {
        //     this.openAutomations();
        //   },
        // },
        {
          display: "three-line-heading",
          primaryHeading: "Last Active",
          middleHeading: contactLastActive(),
        },
        {
          display: "three-line-heading",
          primaryHeading: "Events",
          middleHeading: `Count: ${contactEventCount()} (${formatPrice(
            contactInvoiceTotal()
          )})`,
        },
      ];
      return alerts;
    },
    givenName() {
      return this.contact ? this.contact.given_name : "...";
    },
    familyName() {
      return this.contact ? this.contact.family_name : "...";
    },
    phoneNumber() {
      return this.contact ? this.contact.phoneNumber : "...";
    },
    email() {
      return this.contact ? this.contact.email : "...";
    },
    profilePicture() {
      return this.contact ? this.contact.profilePicture : "../assets/";
    },
    contact() {
      return this.$store.state.contact;
    },
  },
  methods: {
    iconClicked(icon) {
      switch (icon) {
        case "add-note":
          this.openWindow = "add-note";
          break;
        case "edit":
          this.openWindow = "edit-contact";
          break;
        case "reset-password":
          this.openWindow = "reset-password";
          break;
        case "email":
          this.openWindow = "email";
          break;
        case "trash-can":
          this.openWindow = "delete-contact";
          break;
        default:
          break;
      }
    },
    close() {
      this.openWindow = undefined;
    },
  },
  components: {
    Heading,
    IconBar,
    AlertCard,
    UpcomingEvents,
    Notes,
    AutomationsList,
    AddNoteCard,
    DeleteContact,
    EditContact,
    ResetPassword,
    Email,
  },
  created() {
    this.$store.state.contact = this.$store.getters.contacts.find((x) => {
      return x.userId === this.$route.params.userId;
    });
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #contact-page-wrapper {
    width: 100%;
  }
  #contact-page-heading {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 20px;
  }

  #icon-bar {
    margin: 20px;
  }

  #contact-page-components {
    display: flex;
    flex-wrap: wrap;
  }

  #contact-page-alert-scroller {
    display: flex;
    width: 100%;
    align-items: center;
    overflow: scroll;
    padding: 20px;
  }

  #scs-contact-page-upcoming-events {
    min-height: 200px;
    width: 500px;
  }

  #scs-contact-page-automation-list {
    max-height: 500px;
    min-height: 200px;
    width: 500px;
  }

  #scs-contact-page-notes-list {
    width: 500px;
    max-height: 500px;
    min-height: 200px;
  }
  @media (min-width: 800px) {
    #contact-page-wrapper {
      width: 100%;
    }
    #contact-page-heading {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    #contact-page-components {
      display: flex;
      flex-wrap: wrap;
    }

    #contact-page-alert-scroller {
      display: flex;
      width: 100%;
      align-items: center;
      overflow: scroll;
      padding: 20px;
    }

    #scs-contact-page-upcoming-events {
      min-height: 200px;
      width: 500px;
    }

    #scs-contact-page-automation-list {
      max-height: 500px;
      min-height: 200px;
      width: 500px;
    }

    #scs-contact-page-notes-list {
      width: 500px;
      max-height: 500px;
      min-height: 200px;
    }
  }
}
</style>
